import { render } from "./TopStoryPanel.vue?vue&type=template&id=3da0527c"
import script from "./TopStoryPanel.vue?vue&type=script&lang=ts"
export * from "./TopStoryPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script